import { useQuery } from '@tanstack/react-query';
import { makeRequest } from '../../../entry-form-v2/data/makeRequest';

export type AccessHistoryEventType = 'GET_RECORD';

export type CodelistAccessHistoryEvent = {
	id: string;
	eventType: AccessHistoryEventType;
	userId: string;
	createdAt: string;
};

type GetCodelistRecordAccessHistoryResponse = {
	events: CodelistAccessHistoryEvent[];
};

export const useGetCodelistRecordAccessHistoryQuery = (
	args: {
		projectId: string;
		originalEntryId: string;
	},
	opts?: {
		enabled?: boolean;
	}
) => {
	return useQuery({
		queryKey: ['codelist-record-access-history', args.projectId, args.originalEntryId],
		queryFn: () =>
			makeRequest<GetCodelistRecordAccessHistoryResponse>({
				method: 'getCodelistRecordAccessHistory',
				service: 'cde',
				data: {
					projectId: args.projectId,
					originalEntryId: args.originalEntryId
				}
			}),
		...opts
	});
};
